import { useEffect, useState } from "react";

export interface UseInfiniteScrollOptions {
    hasNextPage: boolean;
    isFetchingNextPage: boolean;
    isPaused: boolean;
    onLoadMore: () => void;
}

export function useInfiniteScroll({ hasNextPage, isFetchingNextPage, isPaused, onLoadMore }: UseInfiniteScrollOptions) {
    const [sentinelEl, setSentinelEl] = useState<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!sentinelEl || !hasNextPage || isFetchingNextPage || isPaused) {
            return;
        }

        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    onLoadMore();
                }
            },
            { threshold: 0.1, rootMargin: "0px 0px 300px 0px" }
        );

        observer.observe(sentinelEl);
        return () => observer.disconnect();
    }, [sentinelEl, hasNextPage, isFetchingNextPage, isPaused, onLoadMore]);

    return setSentinelEl;
}
